import { render } from "./BaseMessageInformation.vue?vue&type=template&id=04a947f8"
import script from "./BaseMessageInformation.vue?vue&type=script&lang=js"
export * from "./BaseMessageInformation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__